module.exports = __webpack_public_path__ + "img/updog-subjects.e28aae4a.png";